export const DynamicFieldsSections = {
  QUESTIONS: 'questions',
  DOCUMENTS: 'documents',
} as const
